import RecipeDivider from "./RecipeDivider";

export default function Intro() {
  return (
    <section
      id="intro"
      data-testid="intro-section"
      className="section bg-cream-deep relative"
    >
      <div className="mx-auto max-w-4xl text-center">
        <span className="eyebrow">a heritage table</span>
        <h2 className="mt-5 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))] leading-tight">
          Food that feels like{" "}
          <span className="font-script text-[hsl(var(--rose-deep))]">home</span>,
          served with care.
        </h2>
        <div className="mt-6">
          <RecipeDivider />
        </div>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-[hsl(var(--brown-soft))]">
          Heritage Table Catering brings together family recipes, cultural
          traditions, handcrafted desserts, and comforting meals for the
          moments that matter most. From church gatherings and family
          celebrations to weddings, showers, private dinners, and community
          events, we prepare food that is honest, generous, and beautifully
          served.
        </p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
          {[
            { k: "Family", v: "Recipes passed down" },
            { k: "Cultural", v: "Many traditions" },
            { k: "Handcrafted", v: "Made with care" },
            { k: "Generous", v: "Served beautifully" },
          ].map((item) => (
            <div
              key={item.k}
              className="recipe-card px-4 py-5 text-center"
              data-testid={`intro-value-${item.k.toLowerCase()}`}
            >
              <div className="font-serif-display text-xl text-[hsl(var(--rose-deep))]">
                {item.k}
              </div>
              <div className="mt-1 text-xs tracking-wider text-[hsl(var(--brown-soft))]">
                {item.v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
